import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Btn } from '../../../../../AbstractElements';

const CommonModal = (props) => {
  const textoBtnAceitar = props.textoBtnAceitar || 'Aceitar';
  const onClick = () => {
    props.toggler();
    if (props.onAceitarDeletarPeca) {
      props.onAceitarDeletarPeca();
    }
  }

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggler} size={props.size} centered>
      <ModalHeader toggle={props.toggler}>
        {props.title}
      </ModalHeader>
      <ModalBody className={props.bodyClass}>
        {props.children}
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: props.toggler }} >Fechar</Btn>
        <Btn attrBtn={{ color: 'primary', onClick: onClick }}>{textoBtnAceitar}</Btn>
      </ModalFooter>
    </Modal>
  );
};

export default CommonModal;